<template>
  <div class="row">
    <div class="col-md-12 d-flex justify-content-between">
      <h1 class="h3 mb-3 text-gray-800">
        {{ $t("Relatórios de Benefícios") }}
      </h1>

      <b-dropdown
        no-caret
        variant="primary"
        size="sm"
        v-b-tooltip.hover
        right
        title="Menu de Relatórios de Benefícios"
      >
        <template #button-content>
          Menu
          <i class="fas fa-bars"></i>
        </template>
        <b-dropdown-group
          id="dropdown-group-1"
          header="Relatórios de Benefícios e Concessões"
        >
          <b-dropdown-item
            :to="'/dashboard/relatorios/beneficios/home'"
            :disabled="$route.name == 'relatorios_home_beneficios'"
          >
            Todos os Benefícios
          </b-dropdown-item>
          <b-dropdown-item
            :to="'/dashboard/relatorios/beneficios/concessoes'"
            :disabled="$route.name == 'relatorios_concessoes_beneficios'"
          >
            Concessões de Benefícios
          </b-dropdown-item>
          <b-dropdown-item
            :to="'/dashboard/relatorios/beneficios/graficos'"
            :disabled="$route.name == 'graficos_beneficios'"
          >
            Gráficos de Benefícios
          </b-dropdown-item>
        </b-dropdown-group>
      </b-dropdown>
    </div>
    <div class="col-md-12">
      <load v-if="loading" />
      <router-view v-else />
    </div>
  </div>
</template>
<script>
export default {
  name: "ReportsBenefícios",
  metaInfo() {
    return {
      title: this.$i18n.t("Relatórios de Benefícios"),
    };
  },
  mounted() {},
  data() {
    return {
      loading: false,
    };
  },
  methods: {},
};
</script>
